import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    container: {
        maxWidth: '1240px',
        margin: 'auto',
        backgroundColor: '#E8E8E8',
        padding: '10px',
        '@media print, screen and (min-width: 990px)': {
            padding: '20px 40px'
        },
    },
    appHeader: {
        textAlign: 'center'
    },
    h2: {
        textTransform: 'uppercase',
        color: '#7092a9',
        fontWeight: 'bold',
        position: 'relative',
        paddingBottom: '15px',
	    marginBottom: '20px',

        ':after': {
            content: '\'\'',
            display: 'block',
            position: 'absolute',
            width: '22%',
            height: '4px',
            backgroundColor: '#C01236',
            bottom: '0',
            left: '50%',
            transform: 'translateX(-50%)'
        }
    },
    span: {
        color: '#C01236',
        fontSize: '17px'
    },
    p: {
        fontSize: '14px',
        fontStyle: 'italic',
        color: '#333333',
        maxWidth: '79%',
        margin: '20px auto 40px auto'
    }
});

export default styles;
